import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { URLPaths } from 'app/core/mips/common/utilities/urlPaths.config';
import { RbacService } from './rbac.service';
import { hasPermission } from './rbac.util';

/**
 * Checks the permission required by the route before allowing access.
 * Waits for RBAC to load before evaluating the user's permissions.
 * Unauthorized access is redirected to the landing page.
 */
export const permissionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const required = route.data?.['permission'] as string | undefined;

  return inject(RbacService).ensureLoaded().pipe(
    map((s) =>
      hasPermission(s.rbac?.permissions, required)
        ? true
        : router.createUrlTree([URLPaths.ROUTE_LANDING_PAGE])
    )
  );
};